import api from "./index";

import cookiesHelper from "../helpers/cookies";

import { IProgramForTree } from "../interfaces/tree";
import { ISaveProgram } from "../interfaces/services";

export const getProgramsTree = async (): Promise<IProgramForTree[]> => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`programs/tree`);
        return res.data?.data?.length ? res.data.data : [];
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const saveProgram = async (data: ISaveProgram) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`programs`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const deleteProgram = async (id: number) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`programs/${id}`);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};